import { render, staticRenderFns } from "./TopListItemValue.vue?vue&type=template&id=34401b9d&"
import script from "./TopListItemValue.vue?vue&type=script&lang=ts&"
export * from "./TopListItemValue.vue?vue&type=script&lang=ts&"
import style0 from "./TopListItemValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports